import { HiX } from "react-icons/hi";

interface DeleteImageButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  position?: "top-right" | "top-left" | "top-right-sm" | "top-left-sm";
}

const POSITION_CLASSES = {
  "top-right": "top-1 right-2 text-lg",
  "top-left": "top-1 left-2 text-lg",
  "top-right-sm": "top-1 right-1 text-xs",
  "top-left-sm": "top-1 left-1 text-xs",
};

export function DeleteImageButton({ onClick, position = "top-right" }: DeleteImageButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`absolute z-[99] hidden group-hover/image:block text-white ${POSITION_CLASSES[position]} rounded-md border-2 border-error bg-error shadow-md p-0.5 transition-all duration-200 hover:scale-110 cursor-pointer`}
    >
      <HiX />
    </button>
  );
}
